import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Home/AboutSection.css';

const AboutSection = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="about-wrapper">
          <div className="about-image">
            <img 
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80" 
              alt="Pentagram Infotech Team" 
              className="about-img"
            />
            <div className="experience-badge">
              <span className="years">25+</span>
              <span className="label">Years Experience</span>
            </div>
          </div>
          
          <div className="about-content">
            <div className="section-header">
              <span className="section-label">About Us</span>
              <h2 className="section-title">Pentagram Infotech Technologies Since 2001</h2>
            </div>
            
            <p className="about-description">
              Pentagram Infotech Technologies is a leading IT solutions provider dedicated to helping businesses 
              navigate the complexities of digital transformation. With over 25 years of experience, 
              we've been at the forefront of technological innovation, delivering exceptional 
              solutions to clients across various industries.
            </p>
            
            <div className="about-points">
              <div className="point">
                <i className="bi bi-check-circle-fill"></i>
                <span>Industry-leading expertise in IT solutions</span>
              </div>
              <div className="point">
                <i className="bi bi-check-circle-fill"></i>
                <span>Client-centric approach with tailored solutions</span>
              </div>
              <div className="point">
                <i className="bi bi-check-circle-fill"></i>
                <span>Innovation-driven technology services</span>
              </div>
              <div className="point">
                <i className="bi bi-check-circle-fill"></i>
                <span>Proven track record of successful projects</span>
              </div>
            </div>
            
            <div className="about-stats">
              <div className="stat">
                <h3>500+</h3>
                <p>Projects Completed</p>
              </div>
              <div className="stat">
                <h3>200+</h3>
                <p>Happy Clients</p>
              </div>
              <div className="stat">
                <h3>50+</h3>
                <p>Expert Team</p>
              </div>
            </div>
            
            <div className="about-actions">
              <Link to="/about" className="btn btn-primary">
                Learn More About Us
                <i className="bi bi-arrow-right ms-2"></i>
              </Link>
              <Link to="/contact" className="btn btn-outline">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;